$(() => {
  $('.featured-input').on('change', function featuredClick() {
    axios.get($(this).data('feature-url'), {
      params: {
        featured: $(this).is(':checked') ? $(this).is(':checked') : null
      }
    }).catch(error => console.log(error));
  });
});
